import { createSelector } from '@reduxjs/toolkit';

export const getPage = ()=> {
    return createSelector(
        (state) => state.page,
        (state) => state
    )
}